import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';

export default class HotelSettingsIndexRoute extends Route {
  @service declare access: Services['access'];
  @service declare navigation: Services['navigation'];
  @service declare router: Services['router'];

  private hasFeatureForSettings(featureName: string): boolean {
    if (this.navigation.hasUnifiedHotelView) {
      return this.navigation.hasFeatureInSomeSubscription(featureName);
    }

    return this.access.hasFeature(featureName);
  }

  redirect(): void {
    this.redirectToFirstEnabledSettingsTab();
  }

  private redirectToFirstEnabledSettingsTab(): void {
    if (this.access.hasPersonalSettingsTab) {
      this.router.transitionTo('hotel.settings.personal');
    } else if (
      this.hasFeatureForSettings('settings.compset.app.view') ||
      this.hasFeatureForSettings('settings.compset.rms.view')
    ) {
      this.router.transitionTo('hotel.settings.competitors');
    } else if (this.hasFeatureForSettings('settings.hotel_access.edit')) {
      this.router.transitionTo('hotel.settings.hotels');
    } else if (this.hasFeatureForSettings('reports.view.settings')) {
      this.router.transitionTo('hotel.settings.reports');
    } else if (this.hasFeatureForSettings('spider.settings.edit')) {
      this.router.transitionTo('hotel.settings.spider');
    }
  }
}
